import React, { Component } from 'react';
import { Card, Table, Button, Row, Col, Container } from 'react-bootstrap'
import { listIcon, expandIcon, envelopeIconBlack, mobileIcon  } from '../../img/font_awesome/font_awesome';
import AlertHistoryView from './AlertHistoryView';

const VISIBLE_ROWS = 10; 

class AlertHistory extends Component {

    state = {
        showModal: false
    }

    handleClick = () => {
        this.setState({
            showModal: true
        })
    }

    handleClose = () => {
        this.setState({
            showModal: false
        })
    }

    render() {

        let alertRows = <div style={{ fontWeight: 'bold' }}>No history has been recorded yet.</div>
        let expandButton = <></>
        let detailsButton = <></>

        if (this.props.alertHistoryEvents && this.props.alertHistoryEvents.length > 0) {
            let alertHistoryEvents = this.props.alertHistoryEvents.length > VISIBLE_ROWS ? this.props.alertHistoryEvents.slice(0, VISIBLE_ROWS) : this.props.alertHistoryEvents;
            let moreThanTen = this.props.alertHistoryEvents.length > VISIBLE_ROWS ? true : false;

            alertRows = <Table size='sm'>
                <tbody>
                    <tr>
                    <th className="table-td-xs">Sent</th>
                        <th className="table-td-xs">Alert</th>
                       
                    </tr>
                    {
                        alertHistoryEvents.map((alertHistoryEvent, index) => {
                            return <tr key={index}>
                                <td className="table-td-xs"><span> {alertHistoryEvent.deliveryMethodType === 'EMAIL' ? envelopeIconBlack : mobileIcon}</span> &nbsp;{alertHistoryEvent.deliveredTimestampFormatted}</td>
                                <td className="table-td-xs">{alertHistoryEvent.alertName}</td>
                            </tr>
                        })
                    }
                    { 
                        moreThanTen &&
                        <tr key={"1" + VISIBLE_ROWS}>
                            <td className="table-td-xs"></td>
                            <td className="table-td-xs"><span className='badge badge-light'>more</span></td>
                        </tr>
                    }
                </tbody>
            </Table>

            expandButton = <span onClick={this.handleClick} style={{ cursor: "pointer", float: 'right' }}>{expandIcon}</span>
            detailsButton = <Button variant="primary" className='btn-sm' onClick={this.handleClick}>Details</Button>
        }
     
        return (
            <>
                <Card>
                    <Card.Header style={{ backgroundColor: '' }}>
                        {listIcon}&nbsp;&nbsp;Alert History {expandButton}
                    </Card.Header>
                    <Card.Body>
                        <Container>
                            <Row>
                                <Col>
                                    {alertRows}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {detailsButton}
                                </Col>
                            </Row>
                        </Container>

                    </Card.Body>
                </Card>      
                <AlertHistoryView show={this.state.showModal}  handleClose={this.handleClose} />
            </>
        )
    }
}

export default AlertHistory;
